import { useState } from "react";
import { config } from "../../config";
import { useSupabase } from "../../server/supabase/hooks";

import type { FC } from "react";

export const CeAdminPageHeader: FC = () => {
  const [host, setHost] = useState<string>("loading");

  useSupabase<"ce_admin">(
    async ({ supabase }) => {
      if (!supabase) return;
      setHost(config.db_reverse[new URL(supabase.url).hostname]!);
    },
    [],
    "ce_admin",
  );

  return `CE Admin - ${host}`;
};
